import React, { useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import RegistrationWizard from "views/Forms/Private/EventRegistrationWizard/RegistrationWizard";
import RegistrationWizardContent from "views/Forms/Private/EventRegistrationWizard/RegistrationWIzardContent";
import axios from "axios";
import Swal from 'sweetalert2';
import { useGuestContext } from '../../contexts/GuestContext';
// react-bootstrap components
import {
    Modal,
    Button,
    Nav,
    Container,
    Dropdown,
    Row,
    Col,
} from "react-bootstrap";
import { useDropzone } from 'react-dropzone';

import { Card, ListGroup, ListGroupItem, Alert } from 'reactstrap';

import { UploadCloud, Check, X } from 'react-feather';

function SheetUpload({ uploadModal, setUploadModal }) {

    const {
        acceptedFiles,
        isDragActive,
        isDragAccept,
        isDragReject,
        getRootProps,
        getInputProps
    } = useDropzone({
        accept: 'text/csv',
        reject: '*'
    });
    const { viewingEvent } = useGuestContext();

    // const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
    const files = acceptedFiles.map((file) => (
        <ListGroupItem
            className="font-size-sm px-3 py-2 text-primary d-flex justify-content-between align-items-center"
            key={file.path}>
            <span>{file.path}</span>{' '}
            <span className="badge badge-pill bg-neutral-warning text-warning">
                {file.size} bytes
            </span>
        </ListGroupItem>
    ));

    const handleFileUpload = async () => {
        if (acceptedFiles.length === 0) {
            console.error('No files selected for upload.');
            return;
        }

        const formData = new FormData();
        acceptedFiles.forEach(file => {
            formData.append('files', file);  // 'files' is the field name you expect on the server side
        });

        try {
            const url = viewingEvent === 'baolin15'
                ? `${process.env.REACT_APP_SERVER_URL}/event/bulkregistration`
                : `${process.env.REACT_APP_SERVER_URL}/event/3r5p/bulkregistration`;

            const response = await axios.post(
                url,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    responseType: 'blob'
                }
            );

            // Try to parse JSON from the response
            let jsonResponse;
            try {
                const text = await new Response(response.data).text();
                jsonResponse = JSON.parse(text);
            } catch (e) {
                jsonResponse = null;
            }

            if (jsonResponse) {
                // Handle JSON response
                if (jsonResponse.status === 'success') {
                    Swal.fire({
                        title: 'Success',
                        text: `Records processed successfully. Success: ${jsonResponse.successRecord}, Failed: ${jsonResponse.failedRecord}`,
                        icon: 'success',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setUploadModal(false);
                            window.location.reload(); // Refresh the page
                        }
                    });
                } else {
                    // Handle failure case
                    Swal.fire({
                        title: 'Failed',
                        text: jsonResponse.reason || 'Failed to process records',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            setUploadModal(false); // Close the modal
                            window.location.reload(); // Refresh the page
                        }
                    });
                }
            } else {
                // Handle file download response
                const contentDisposition = response.headers['content-disposition'];
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="?(.+)"?/);
                    if (match && match[1]) {
                        const filename = match[1].replace(/['"]+/g, '');
                        const blob = new Blob([response.data], { type: 'text/csv' });

                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = filename;
                        document.body.appendChild(link);
                        link.click();

                        window.URL.revokeObjectURL(link.href);
                        document.body.removeChild(link);

                        // Display SweetAlert message after file download
                        Swal.fire({
                            title: 'Attention',
                            text: 'There are registrations failed to process. Please refer to the downloaded file for details on any failed entries.',
                            icon: 'warning',
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.isConfirmed) {
                                setUploadModal(false); // Close the modal
                                window.location.reload(); // Refresh the page
                            }
                        });
                    }
                }
            }

        } catch (error) {
            console.error('Error uploading files:', error);
            Swal.fire('Error', 'An error occurred. Please try again later.', 'error');
        }
    };


    return (
        <>
            <Modal
                className=" modal-primary"
                onHide={() => setUploadModal(!uploadModal)}
                show={uploadModal}
                size="lg"
            >
                <Modal.Body className="text-center">
                    <div className="dropzone">
                        <div {...getRootProps({ className: 'dropzone-upload-wrapper' })}>
                            <input {...getInputProps()} />
                            <div className="dropzone-inner-wrapper text-center">
                                {isDragAccept && (
                                    <div>
                                        <div className=" d-flex justify-content-center align-items-center btn-icon mb-3 hover-scale-lg bg-success shadow-success-sm rounded-circle text-white" style={{ width: '100px', height: '100px', marginLeft: '2rem' }}>
                                            <Check size={50} />
                                        </div>
                                        <div className="font-size-sm text-success">
                                            All files will be uploaded!
                                        </div>
                                    </div>
                                )}
                                {isDragReject && (
                                    <div>
                                        <div className="d-100 btn-icon mb-3 hover-scale-lg bg-danger shadow-danger-sm rounded-circle text-white">
                                            <X size={50} />
                                        </div>
                                        <div className="font-size-sm text-danger">
                                            None CSV files will be rejected!
                                        </div>
                                    </div>
                                )}
                                {!isDragActive && (
                                    <div className="text-center">
                                        <div className=" d-flex justify-content-center align-items-center mb-3 bg-white shadow-light-sm rounded-circle text-primary" style={{ width: '100px', height: '100px', marginLeft: '2rem' }}>
                                            <UploadCloud size={60} />
                                        </div>
                                        <div className="font-size-sm">
                                            Drag and drop files here{' '}
                                            <div className="font-size-xs text-dark">
                                                (CSV files only)
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <small className="py-2 text-black-50">or</small>
                                <div>
                                    <Button
                                        color="primary"
                                        className="hover-scale-sm font-weight-bold btn-pill px-4">
                                        <span className="px-2">Browse Files</span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="font-weight-bold my-4 text-uppercase text-dark font-size-sm text-center">
                            Files to be Uploaded
                        </div>
                        {files.length <= 0 && (
                            <div className="text-info text-center font-size-sm">
                                Files to be Uploaded will appear here!
                            </div>
                        )}
                        {files.length > 0 && (
                            <div>
                                <Alert color="success" className="text-center mb-3">
                                    You are going to upload <b>{files.length}</b> files!
                                </Alert>
                                <ListGroup className="font-size-sm">{files}</ListGroup>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setUploadModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleFileUpload}>
                        Upload File
                    </Button>
                </Modal.Footer>

            </Modal>
        </>
    );
}

export default SheetUpload;
